export default __webpack_public_path__ + "static/media/1106.2736c9a1.png";